/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithFileItemRequestBuilder, WithFileItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /shares/directories/{token}/files
 */
export interface FilesRequestBuilder extends BaseRequestBuilder<FilesRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.shares.directories.item.files.item collection
     * @param fileId Unique identifier of the item
     * @returns {WithFileItemRequestBuilder}
     */
     byFileId(fileId: Guid) : WithFileItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const FilesRequestBuilderUriTemplate = "{+baseurl}/shares/directories/{token}/files";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FilesRequestBuilderNavigationMetadata: Record<Exclude<keyof FilesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byFileId: {
        navigationMetadata: WithFileItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["fileId"],
    },
};
/* tslint:enable */
/* eslint-enable */
